// extracted by mini-css-extract-plugin
export var cartContainer = "_n5-4";
export var gray = "_n5-1";
export var itemContainer = "_n5-2";
export var itemDetails = "_n5-3";
export var strong = "_n5-0";